<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <search-item
          ref="searchItem"
          config-module="940"
          :reset="true"
          :custom-search-items="customSearchItems"
          @click-more="value=>{isAdvancedQuery=value}"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
        >
          <div slot="operations" style="display: flex;">
            <div v-show="!isAdvancedQuery" style="margin-right: 5px;">
              <el-radio-group v-model="isJobNo" no="1">
                <el-radio :label="1" style="margin-right: 5px;">{{ $t('SeaExport.BusinessNo') }}</el-radio>
                <el-radio :label="0" style="margin-right: 5px;">{{ $t('SeaExport.BlNo') }}</el-radio>
              </el-radio-group>
              <el-input
                v-model="jobNo"
                :placeholder="$t('CargoMsg.Cargo_PlsInput')+(isJobNo?$t('SeaExport.BusinessNo'):$t('SeaExport.BlNo'))"
                style="width: 150px;"
                no="2"
              />
            </div>
            <el-button
              v-permission="['button_AERouteCentral_BillingMAWB']"
              type="primary"
              :disabled="!btBillingMAWBEnabled"
              no="3"
              @click="billingType('btBillingMAWB')"
            >{{ $t('queryJob.prefabricatedMasterOrder') }}</el-button>
            <el-button
              v-permission="['button_AERouteCentral_BillingMAWB']"
              type="primary"
              :disabled="!btBillingHAWBEnabled"
              no="4"
              @click="billingType('btBillingHAWB')"
            >{{ $t('queryJob.prefabricationOrderSplitting') }}</el-button>
            <el-button
              v-permission="['button_AERouteCentral_BillingMAWB']"
              type="primary"
              :disabled="!btPrintMAWBEnabled"
              no="5"
              @click="billingType('btPrintMAWB')"
            >{{ $t('queryJob.printMasterOrder') }}</el-button>
            <el-button
              v-permission="['button_AERouteCentral_BillingMAWB']"
              type="primary"
              :disabled="!btPrintHAWBEnabled"
              no="6"
              @click="billingType('btPrintHAWB')"
            >{{ $t('queryJob.printSplit') }}</el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper" style="min-height: 350px;">
          <cargo-ag-grid
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :check-main-record="false"
            :deselect-main-record="false"
            :auto-fit-content="false"
            style="width: 100%;"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination :total="total" :page.sync="pageNum" :limit.sync="pageSize" @pagination="toPageQuery" />
        </div>
      </div>
    </div>
    <!-- 预制主单/分单对话框 -->
    <billingDialog
      :visible.sync="billingDialog.visible"
      :job="billingDialog.job"
      :show-basic="true"
      :doc-type="billingDialog.docType"
      @callback="billingDialog.callback"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 查询进仓照片 -->
    <picture-view-window
      :visible.sync="pictureView.visible"
      :job="pictureView.job"
      :model="pictureView.model"
      :title="pictureView.title"
      :file-name="pictureView.fileName"
      :type="pictureView.type"
    />
  </div>
</template>

<script>
import photo_camera from '@/assets/photo_camera-32.png'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import pictureViewWindow from '@/components/Cargo/Job/pictureViewWindow'
import billingDialog from './components/routeCentral/billingDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { DocumentManage, stopBubble } from '@/utils/commonUtil'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { documentMoreQuery } from '@/api/AirExport/airExportJob'
import { updateCargoDoc } from '@/api/seaExport/cargoDoc'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtil from '@/utils/ColumnUtils'

export default {
  name: 'AePrepareDocument',
  components: { searchItem, cargoTemplateSelectorDialog, pictureViewWindow, billingDialog },
  data() {
    const searchField = new AdvancedSearchField()
    searchField.action = AdvancedSearchField.UPDATE_ACTION
    searchField.itemType = 'select'
    searchField.fieldType = 'FIELD_RADIO'
    searchField.itemName = 'cargoDoc.DOC_TYPE'
    searchField.itemLabel = 'SeaExport.BlProperty'
    searchField.defaultSelected = 1
    searchField.dataProvider = [
      { code: 'MAWB', chineseName: '主单', englishName: 'Main Order' },
      { code: 'HAWB', chineseName: '分单', englishName: 'Sub Order' }
    ]
    searchField.defaultValue = 'MAWB'
    const customSearchItems = [searchField.formatObj2Json()]
    return {
      loading: null,
      customSearchItems,
      oldIsAdvanceQuery: false, // 记录上一次操作是否为高级查询
      isAdvancedQuery: false, // 是否为高级查询
      isJobNo: 1, // 是否输入业务编号
      jobNo: '',
      pageNum: 1,
      pageSize: 50,
      total: 0,
      rowData: [],
      selectedNode: null,
      btBillingMAWBEnabled: false,
      btBillingHAWBEnabled: false,
      btPrintMAWBEnabled: false,
      btPrintHAWBEnabled: false,
      billingDialog: {
        visible: false,
        job: {},
        docType: '',
        callback: () => {
          this.selectedNode.setData(this.selectedRow)
          this.delayUpdateButtonState()
        }
      },
      templateSelectorDialog: {
        visible: false,
        ctx: null,
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      // 图片展示
      pictureView: {
        visible: false,
        title: '',
        model: {},
        fileName: '',
        job: {},
        type: 'WarehouseIn'
      }
    }
  },
  computed: {
    filter() {
      return this.isAdvancedQuery ? this.complexFilter : this.simpleFilter
    },
    selectedRow() {
      return this.selectedNode ? this.selectedNode.data : null
    }
  },
  watch: {
    selectedRow(newVal, oldVal) {
      this.delayUpdateButtonState()
    }
  },
  created() {
    // 扩展data
    Object.assign(this, {
      simpleFilter: {
        conditions: [],
        branchId: 0
      },
      complexFilter: {
        conditions: [],
        branchId: 0
      },
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        treeData: true,
        groupDefaultExpanded: 0,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.BusinessNo'),
          field: 'jobNo',
          width: 240,
          cellRendererParams: {
            suppressCount: true
          }
        },
        onRowDataChanged: event => {
          /* 清除单选行 */
          this.selectedNode = null
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            this.selectedNode = null
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_BLNo'),
          field: 'mbl',
          width: 100
        }, {
          headerName: this.$t('SeaExport.Hbl2'),
          field: 'hawb',
          width: 100
        }, {
          headerName: this.$t('SeaExport.AirlineCompany'),
          field: 'carrierId',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'shortName')
          }
        }, {
          headerName: this.$t('SeaExport.FlightNo'),
          field: 'voyageFlight',
          width: 100
        }, {
          headerName: this.$t('SeaExport.DateOfDeparture'),
          field: 'etd',
          cellRenderer: params => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_PortOfLoading'),
          field: 'loadingPortCode',
          width: 100,
          tooltipValueGetter: (params) => {
            if (params.data.loadingPortCode) {
              return ColumnUtil.portLabelFunc(params.data, params.value)
            } else {
              return ''
            }
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_DestinationPort'),
          field: 'destinationPortCode',
          width: 100,
          tooltipValueGetter: (params) => {
            if (params.data.destinationPortCode) {
              return ColumnUtil.portLabelFunc(params.data, params.value)
            } else {
              return ''
            }
          }
        }, {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantityActual',
          cellRenderer: params => {
            return ColumnUtils.formatNumber(params.value, 0, true)
          },
          width: 100
        }, {
          headerName: this.$t('SeaExport.Weight2'),
          field: 'weightActual',
          cellRenderer: params => {
            return ColumnUtils.formatNumber(params.value, 1, true)
          },
          width: 100
        }, {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubageActual',
          cellRenderer: params => {
            return ColumnUtils.formatNumber(params.value, 3, true)
          },
          width: 100
        }, {
          headerName: this.$t('queryJob.size'),
          field: 'measurements',
          cellRenderer: params => {
            const data = params.data
            let s = ''
            if (data.warehouseIn && data.warehouseIn.length > 0) {
              for (const warehouseIn of data.warehouseIn) {
                for (const detail of warehouseIn.warehouseInDetail) {
                  if (s.length > 0) {
                    s += ','
                  }
                  s += detail.dimension
                }
              }
            } else {
              s = data.measurements
            }
            const pics = this.getPics(data)
            if (pics.length > 0) {
              const methodPath = this.documentManage.getPath('showAttachHandler')
              return `<img src="${photo_camera}" height="16" width="16" style="vertical-align: middle;margin-right: 3px;cursor: pointer;" onclick="${methodPath}(event)"/>${s}`
            }
            return s
          },
          width: 100
        }, {
          headerName: this.$t('AirExport.MasterBillStatus'),
          field: 'airCargoDoc',
          colId: 'mblState',
          cellRenderer: params => {
            const job = params.data
            const billFlagMBL = job.masterFlag || job.operateType === AirExportConstants.BACK_TO_BACK.code || job.operateType === AirExportConstants.DIRECT.code
            if (billFlagMBL && job.airCargoDoc && job.airCargoDoc.length > 0) {
              const mblDoc = job.airCargoDoc.find(p => p.docType === 'MAWB')
              if (mblDoc) {
                const text = this.getCommonStateName(mblDoc.state)
                const mblOrHblLinkMethod = this.documentManage.getPath('mblOrHblLink')
                return `<a href="javascript:void(0)"  style="border-bottom: 1px solid;color: blue;" onclick="${mblOrHblLinkMethod}(event,'MAWB')">${text}</a>`
              }
            }
            return ''
          },
          width: 120,
          tooltipValueGetter: (params) => {
            return ''
          }
        }, {
          headerName: this.$t('AirExport.SubBillStatus'),
          field: 'airCargoDoc',
          colId: 'hblState',
          cellRenderer: params => {
            const job = params.data
            const billHBL = !job.masterFlag && job.operateType !== AirExportConstants.DIRECT.code
            if (billHBL && job.airCargoDoc && job.airCargoDoc.length > 0) {
              const hblDoc = job.airCargoDoc.find(p => p.docType === 'HAWB')
              if (hblDoc) {
                const text = this.getCommonStateName(hblDoc.state)
                const mblOrHblLinkMethod = this.documentManage.getPath('mblOrHblLink')
                return `<a href="javascript:void(0)"  style="border-bottom: 1px solid;color: blue;" onclick="${mblOrHblLinkMethod}(event,'HAWB')">${text}</a>`
              }
            }
            return ''
          },
          width: 120,
          tooltipValueGetter: (params) => {
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.OperatingInstructions'),
          field: 'remarks',
          width: 200
        }
      ],
      gridApi: null,
      updateBtnStateSeq: 1, // 执行更新按钮状态操作的次序
      documentManage: new DocumentManage()
    })
  },
  beforeMount() {
    const self = this
    this.documentManage.set('showAttachHandler', function(e) {
      self.showAttachHandler(e)
    })
    this.documentManage.set('mblOrHblLink', function(e, docType) {
      self.mblOrHblLink(e, docType)
    })
  },
  mounted() {
    this.$refs.searchItem.keyWords = 'keyWords' // 该输入框用不到，但必须有值，否则简单查询无法验证通过
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 查询[简单查询/高级查询]
    toPageQuery() {
      if (this.filter.conditions.length === 0) {
        if (this.isAdvancedQuery) {
          this.$refs.searchItem.advSearch()
        } else {
          this.$refs.searchItem.simSearch()
        }
        return
      }
      if (this.isAdvancedQuery !== this.oldIsAdvanceQuery) {
        this.pageNum = 1
        this.oldIsAdvanceQuery = this.isAdvancedQuery
      }
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 简单查询
    toSimpleQuery(keyword) {
      let data
      if (typeof keyword !== 'undefined') {
        if (!this.jobNo) {
          this.$message.info(this.$t('AirExport.EnterQueryInformation'))
          return
        }
        // 覆盖原查询条件
        if (this.isJobNo) {
          data = [new AdvancedSearchOption(null, 'job.JOB_NO', this.jobNo, 'LIKE').formatObj2Json()]
        } else {
          data = [new AdvancedSearchOption(null, 'job.MBL', this.jobNo, 'LIKE').formatObj2Json()]
        }
      }
      this.toAdvancedQuery(data)
    },
    // 高级查询
    toAdvancedQuery(data) {
      const filter = this.filter
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        filter.conditions = this.handleConditionsBeforeQuery(data)
        this.pageNum = 1
      }
      filter.branchId = this.$store.getters.currentOfficeId
      filter.pageNum = this.pageNum
      filter.pageSize = this.pageSize
      this.loading = getLoading()
      documentMoreQuery(filter).then(res => {
        this.rowData = res.data.list
        this.pageNum = res.data.pageNum
        this.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 在查询之前，对条件进行预处理
    handleConditionsBeforeQuery(data) {
      data.push(new AdvancedSearchOption(null, 'job.OP_OFFICE', this.$store.getters.currentOfficeId).formatObj2Json())
      if (this.isAdvancedQuery) {
        // 制单状态
        const option = AdvancedSearchOption.getOption('cargoDoc.STATE', data)
        if (option && option.value === -1) {
          AdvancedSearchOption.removeOption('cargoDoc.STATE', data)
        }
      }
      return data
    },
    getCommonStateName(state) {
      if (state < 3) {
        return this.$t('CargoMsg.Cargo_PositiveOperation')
      }
      return CommonState.getNameByCode(SystemConstants.DOC_STATES, String(state))
    },
    getPics(job) {
      const pics = []
      if (job && job.warehouseIn) {
        for (const item of job.warehouseIn) {
          if (item.businessDocument) {
            pics.push(...item.businessDocument)
          }
        }
      }
      return pics
    },
    // 显示进仓图片
    showAttachHandler(e) {
      stopBubble(e)
      const nodes = this.gridApi.rowModel.rowsToDisplay
      const cell = this.gridApi.getFocusedCell()
      const row = nodes[cell.rowIndex].data
      const model = { ...row.warehouseIn[0] }
      model.businessDocument = this.getPics(row)
      this.pictureView.title = this.$t('Message.ViewWarehouseEntryPhotos')
      this.pictureView.model = model
      this.pictureView.fileName = row.warehouseNo + '.zip'
      this.pictureView.type = 'WarehouseIn'
      this.pictureView.job = row
      this.pictureView.visible = true
    },
    // 提单主单/分单链接
    mblOrHblLink(e, docType) {
      stopBubble(e)
      this.billing(docType)
    },
    // 延迟更新按钮状态，避免频繁执行
    delayUpdateButtonState() {
      setTimeout(seq => {
        if (seq >= this.updateBtnStateSeq) {
          this.updateButtonState()
        }
      }, 100, ++this.updateBtnStateSeq)
    },
    updateButtonState() {
      const item = this.selectedRow
      if (item) {
        const billFlagMBL = item.masterFlag || item.operateType === AirExportConstants.BACK_TO_BACK.code || item.operateType === AirExportConstants.DIRECT.code
        this.btBillingMAWBEnabled = billFlagMBL
        if (billFlagMBL) {
          new AirExportJob(item).getCargoDoc(CargoDocConsts.MAWB, false).then(cargoDoc => {
            this.btPrintMAWBEnabled = cargoDoc && cargoDoc.state === 5
          })
        } else {
          this.btPrintMAWBEnabled = false
        }
        const billHBL = !item.masterFlag && item.operateType !== AirExportConstants.DIRECT.code
        this.btBillingHAWBEnabled = billHBL
        if (billHBL) {
          new AirExportJob(item).getCargoDoc(CargoDocConsts.HAWB, false).then(cargoDoc => {
            this.btPrintHAWBEnabled = cargoDoc && cargoDoc.state === 5
          })
        } else {
          this.btPrintHAWBEnabled = false
        }
      } else {
        this.btBillingHAWBEnabled = false
        this.btBillingMAWBEnabled = false
        this.btPrintHAWBEnabled = false
        this.btPrintMAWBEnabled = false
      }
    },
    billingType(index) {
      switch (index) {
        case 'btBillingMAWB':
          this.billing('MAWB')
          break
        case 'btBillingHAWB':
          this.billing('HAWB')
          break
        case 'btPrintMAWB':
          this.printCargoDoc('MAWB')
          break
        case 'btPrintHAWB':
          this.printCargoDoc('HAWB')
          break
        default:
          break
      }
    },
    billing(docType) {
      this.billingDialog.job = this.selectedRow
      this.billingDialog.docType = docType
      this.billingDialog.visible = true
    },
    async printCargoDoc(docType) {
      const job = this.selectedRow
      const cargoDoc = await new AirExportJob(job).getCargoDoc(docType, false)
      if (!cargoDoc) {
        return
      }
      this.templateSelectorDialog.ctx = new AirExportJob(job)
      this.templateSelectorDialog.category = docType === CargoDocConsts.HAWB ? 'AEHAWB' : 'AEMAWB'
      this.templateSelectorDialog.data = { JOB_UUID: job.uuid, DOC_UUID: cargoDoc.uuid, cargoDocUuid: cargoDoc.uuid }
      this.printedCallback = event => {
        const data = { ...cargoDoc }
        data.state = 3
        updateCargoDoc(data, { selectiveType: 'state' }).then(res => {
          Object.assign(cargoDoc, res.data)
          this.gridApi.refreshCells({ force: true })
          this.delayUpdateButtonState()
        })
      }
      this.templateSelectorDialog.visible = true
    }
  }
}
</script>

<style scoped lang="scss">
#app .app-main-content .grid-view .main-content ::v-deep {
  .cargo-advance-search-quick {
    .el-input {
      display: none;
    }
  }
  .grid-wrapper {
    .ag-theme-balham {
      .ag-row-hover {
        background: #9bddff !important;
      }
    }
  }
}
</style>
